import { billingsService } from "@/_services";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
export const pdfInvoiceMixin = {
  methods: {
    downloadPDF(payment) {
      billingsService.downloadPDF(payment.id).then(result => {
        const pdf = new jsPDF('p', 'pt', [595.28, 841.89]);
        const logo = require('@/assets/images/logo-h.png')

        const doc = new jsPDF()
        var imgLogo = new Image()
        imgLogo.src = logo


        pdf.addImage(imgLogo, 'JPEG', 40, 50, 185, 50);
        
        // pdf.setFontSize(26);
        // pdf.setTextColor(81, 85, 236);
        // pdf.text(400, 40, 'OLIVERLIST');

        pdf.setFontSize(9);
        pdf.setTextColor(150);
        pdf.text(500, 60, 'AIVONI SAS');
        pdf.text(420, 72, '4, avenue Jean-Baptiste Clément');
        pdf.text(442, 84, '92100 Boulogne Billancourt');
        pdf.text(447, 96, 'N° Siret: 80878516600030');
        pdf.text(501, 108, 'NAF.: 6201Z');
        pdf.text(443, 120, 'TVA CEE: FR32808785166');

        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(0, 150, 250, 20, 'F');

        pdf.setFontSize(22);
        pdf.setFontType("bold");
        pdf.setTextColor(255);
        pdf.text(145, 167, 'INVOICE');

        pdf.setTextColor(100);

        let invoice = result.data;
        let d = new Date(invoice.created);
        let year_digits = d.getFullYear().toString().substr(-2);
        let invoiceId = year_digits + 'OL' + invoice.invoice_id.toString().padStart(10, "0");
        pdf.setFontType("normal");
        pdf.setFontSize(11);
        pdf.text(40, 185, 'Invoice number: ' + invoiceId);

        const monthNames = ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        let year = d.getFullYear().toString();
        let invoiceDate =  d.getDate() + ' ' + monthNames[d.getMonth()] + ', ' + year;
        pdf.text(40, 200, 'Invoice date: ' + invoiceDate) ;

        if (invoice.ingenico_pay_id != undefined) {
          pdf.text(40, 215, 'Billing id: ' + invoice.ingenico_pay_id);
        }

        let client = result.data;
        if (client.name) {
          pdf.setFontSize(12);
          pdf.setTextColor(150);
          pdf.text(40, 230, 'Invoice to: ');
          pdf.setFontSize(10);
          pdf.setFontType("bold");
          pdf.text(40, 245, client.name);
          pdf.setFontType("normal");
          pdf.text(40, 260, client.legal_representative);
          pdf.text(40, 275, client.address);
          pdf.text(40, 290, client.country);
        }

        pdf.autoTableSetDefaults({
          headStyles: { fillColor: [81, 85, 236] }, // Purple
        })

        var data = result.data;

        var total = result.data.total;
        var discount_amount = result.data.discount_amount;
        var discount_previous_payment = result.data.discount_previous_payment;
        total = (total - discount_amount - discount_previous_payment).toFixed(2);
        var totalWithVat = result.data.total_with_vat;
        var totalVat = totalWithVat - total;
        totalVat = (Math.round(totalVat * 100) / 100).toFixed(2);

        var percentage = Math.trunc(totalVat * 100 / total);

        result.data.total = result.data.total + ' €';

        let discount = (result.data.discount * 100 / 100).toFixed(0);
        let discount_data = {};

        let discount_previous_payment_data = {};

        if (discount_previous_payment > 0) {
          discount_previous_payment_data = { date: "Prorata refund old plan", total: "- " + discount_previous_payment + ' €' };
        }

        if (discount > 0) {
          discount_data = { date: "Remise (" + discount + " %)", total: "- " + result.data.discount_amount + ' €' };
        }

        let items = [];

        if (invoice.items != undefined) {
          invoice.items.forEach(item => {
            let description = '['+item.name + ' ' + item.lastname + '] ' + item.business_name + ' ' + item.event_date + ' - (' + item.amount + ' €)'
            items.push({ date: '', description: description })
          });
        }

        let lines = [data].concat(items);
        lines = lines.concat([discount_previous_payment_data, discount_data]);
        // var firstElement = data[0];
        // firstElement.date = billing.start_date + '  -  ' + billing.end_date ;
        pdf.autoTable({
          startY: 320,
          body: lines,
          columns: [
            { header: 'Date', dataKey: 'date' },
            { header: 'Description', dataKey: 'description' },
            // { header: 'Qty', dataKey: 'quantity' },
            // { header: 'Unit Price', dataKey: 'amount' },
            { header: 'Total in EUR', dataKey: 'total' },
          ],
          columnStyles: {
            2: { halign: 'right' }
          },
          didDrawCell: function (hookData) {
            if (hookData.section === 'body') {
              if (hookData.row.index === 0) {
                for (const cell of Object.values(hookData.row.cells)) {
                  cell.styles.fontStyle = 'bold';
                }
              }
            }
          },
        })


        var body = [];
        body.push({ field: "Subtotal in EUR", value: total + ' €' });
        body.push({ field: "VAT (" + percentage + "%)", value: totalVat + ' €' });
        body.push({ field: "Total in EUR", value: totalWithVat + ' €' });
        pdf.autoTable({
          startY: pdf.lastAutoTable.finalY + 40,
          tableWidth: 200,
          theme: 'grid',
          minCellHeight: 30,
          margin: { left: 350 },
          head: [{ field: '', value: '' },],
          body: body,
          showHead: false,
          columnStyles: {
            field: { fontStyle: 'bold', cellPadding: 7 },
            value: { cellPadding: 7, halign: 'right' }
          },
        })

        //pdf.setFontType("bold");
        pdf.setFontSize(8);
        pdf.setTextColor(150);
        if(data.payment_date != null){
          // let CollectionId
         let paymentDate = new Date(data.payment_date);
         const paymentYear = paymentDate.getFullYear().toString().substr(-2);
         const paymentMonth = String(paymentDate.getMonth() + 1).padStart(2, '0');
         const paymentDay = String(paymentDate.getDay() + 1).padStart(2, '0');
         let collectionId = paymentDay + paymentMonth + paymentYear;
           pdf.text(40, pdf.lastAutoTable.finalY + 20, 'Collection id: '+collectionId);
         }
        pdf.text(40, pdf.lastAutoTable.finalY + 35, 'The invoice was generated electronically and automatically, without a cash register.');
        pdf.text(40, pdf.lastAutoTable.finalY + 50, 'This is the original electronic version.');

        pdf.text(40, pdf.lastAutoTable.finalY + 65, 'Payment Date: '+invoiceDate);
        pdf.text(40, pdf.lastAutoTable.finalY + 80, 'Payment method: Credit card ');
        pdf.text(40, pdf.lastAutoTable.finalY + 95, 'Discount conditions: No discount is applied.');
        pdf.text(40, pdf.lastAutoTable.finalY + 110, 'Penalty conditions: Any delay in payment of the invoice will result in the immediate application of an annual interest rate of  ');
        pdf.text(40, pdf.lastAutoTable.finalY + 125, '12% on the unpaid amounts as well as 40 € for collection costs, in accordance with art L 4414-10 of the French Commercial Code.');

        pdf.save('invoice-' + invoiceId + '.pdf');
      }
      );
    }
  }
}